import { observer } from 'mobx-react';
import Modal from '../../../../../../Modal';
import InviteParticipantStore from '../Store';
import Body from './Body';
import { Link } from '../../../../../../../Resource/Types';
import { DownloadProgram } from '../Types';

interface Props {
  store: InviteParticipantStore;
  link: Link;
  state: DownloadProgram;
}

export const resetModal = (store: InviteParticipantStore) => {
  store.modalStore.close();
  store.waiting();
};

function DownloadModel({ store, link, state }: Props) {
  switch (store.modalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <Modal
          close={() => resetModal(store)}
          title={<></>}
          customBackgroundCssClasses="bg-teal-100 opacity-60"
          modalWidth="w-2/5"
        >
          <Body
            store={store}
            link={link}
            totalDeepLinkCount={state.totalDeepLinkCount}
            filteredDeepLinkCount={state.filteredDeepLinkCount}
          />
        </Modal>
      );
  }
}

export default observer(DownloadModel);
